import React from "react";

const MultiSelectDisplayRenderer = (props) => {
  const { api, node, column, value, id, field } = props;
  const summary = Array.isArray(value) ? value.join(", ") : "";
  const openEditor = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    // Try AG Grid path first if available
    if (api?.startEditingCell && node && column?.getColId) {
      const colId = column.getColId();
      try {
        api.setFocusedCell?.(node.rowIndex, colId);
      } catch (_) {}
      setTimeout(() => {
        try {
          api.startEditingCell({ rowIndex: node.rowIndex, colKey: colId });
        } catch (_) {}
      }, 0);
      return;
    }
    // Fallback to MUI DataGrid path
    if (api?.startCellEditMode && id && field) {
      try {
        api.startCellEditMode({ id, field });
      } catch (_) {}
    }
  };
  return (
    <div className="w-full min-w-0 flex items-center justify-between gap-2">
      <span className="truncate">{summary}</span>
      <button
        type="button"
        aria-label="Edit"
        className="shrink-0 px-2 py-0.5 text-xs rounded border border-slate-300 bg-white hover:bg-slate-50"
        onClick={openEditor}
      >
        ▼
      </button>
    </div>
  );
};

export default MultiSelectDisplayRenderer;
